import React from 'react'
import { Button } from '@mui/material'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { PageActionButton } from 'uiComponents/buttons/pageAddButton'
import { DatePicker } from 'uiComponents/popups/datePickerInput'
import { FormItem } from 'uiComponents/form/formElements'
import './dateControls.scss'
import { Trans, useTranslation } from 'translations'

interface DateControlsProps {
    selectedDate: Date
    handleDateChange: (date: Date) => void
    stepDate: (step: 'increment' | 'decrement') => () => void
    ordersCount: number
}

export const DateControls: React.FC<DateControlsProps> = ({
    selectedDate,
    handleDateChange,
    stepDate,
    ordersCount,
}) => {
    const { t } = useTranslation()
    return (
        <div className="date-picker-container">
            <FormItem className="date-picker" htmlFor="validFrom">
                <DatePicker
                    id="selectedDate"
                    date={selectedDate ? new Date(selectedDate) : null}
                    onChange={handleDateChange}
                />
            </FormItem>
            <div className="day-step-button-container">
                <Button
                    className="day-step-button"
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={stepDate('decrement')}
                >
                    <ChevronLeft size={16} />
                </Button>
                <PageActionButton onClick={() => handleDateChange(new Date())}>
                    {t('orders.dailySchedule.today')}
                </PageActionButton>
                <Button
                    className="day-step-button"
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={stepDate('increment')}
                >
                    <ChevronRight size={16} />
                </Button>
            </div>
            <div className="order-count">
                <Trans
                    i18nKey="orders.dailySchedule.ordersOnDate"
                    values={{ ordersCount }}
                    components={{ strong: <strong /> }}
                />
            </div>
        </div>
    )
}
